import { memo, useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { FormFieldLayout } from "../../layouts";

type Props = {
	discountCode: ForNodeType<string>;
	onChangeCode: (value: string) => void;
};

export const DiscountCodeFormFieldComposition = memo(({ discountCode, onChangeCode }: Props) => {
	/**
	 * ディスカウントコードの変更
	 */
	const handleChangeDiscountCode = useCallback(
		(value: string) => {
			onChangeCode(value);
		},
		[onChangeCode],
	);

	return (
		<FormFieldLayout title="ディスカウントコード">
			<div className="space-y-2">
				<InputTextField
					value={discountCode.value}
					errorMessage={discountCode.error}
					handleChange={handleChangeDiscountCode}
				/>

				<p className="whitespace-pre-wrap text-sm text-caption-50">
					お客様が入力するディスカウントコードを設定しましょう。
				</p>
			</div>
		</FormFieldLayout>
	);
});
